export default "__VITE_ASSET__4ae9eaa4__"